class ToggleAVGemak {
    constructor(element) {
        this.container = element;
        this.context = "";
        this.disableAvGemak = this.container.dataset.disableAvGemak;
        this.bvSelect = this.container.querySelector("[data-select-bv]");
        this.avSelect = this.container.querySelector("[data-select-av]");
        this.avSelectContainer = this.container.querySelector(
            "[data-select-av-container]"
        );
        this.avSelectCarousel = this.container.querySelector(
            "[data-select-av-carousel]"
        );
        this.avSelectCarouselButton = this.container.querySelector(
            "[data-select-av-carousel-button]"
        );
        this.bvZorgGemakValue = "ZVW-ZWGMK";
        this.bvGeenValue = "Geen-Geen";

        this._init();
    }

    _init() {
        if (!this.disableAvGemak || this.disableAvGemak === "false") return;

        this._checkContext();
        this._initOnLoad();
        this._assignListeners();
    }

    _checkContext() {
        this.bvSelect.tagName === "SELECT"
            ? (this.context = "select")
            : (this.context = "carousel");
    }

    _initOnLoad() {
        this.context === "carousel"
            ? this._setupCarouselOnLoad()
            : this._setupSelectOnLoad();
    }

    _assignListeners() {
        this.context === "carousel"
            ? this.setupCarouselOnChange()
            : this.setupSelectOnChange();
    }

    _setupCarouselOnLoad() {
        let bvSelectInputs = this.bvSelect.querySelectorAll("input");

        for (let input of Array.from(bvSelectInputs)) {
            input.checked && this._checkSelectedBV({ target: input });
        }
    }

    _setupSelectOnLoad() {
        this._checkSelectedBV({ target: this.bvSelect });
    }

    setupCarouselOnChange() {
        let bvSelectInputs = this.bvSelect.querySelectorAll("input");
        for (let input of Array.from(bvSelectInputs)) {
            this._onChange(input);
        }
    }

    setupSelectOnChange() {
        this._onChange(this.bvSelect);
    }

    _onChange(element) {
        element.addEventListener("change", this._checkSelectedBV.bind(this));
    }

    _checkSelectedBV(input = false) {
        const bvSelectElement = input.target || this.bvSelect;
        const bvSelectValue = bvSelectElement.value;

        bvSelectValue && this._toggleAVGemak(bvSelectValue);
    }

    _toggleAVGemak(selectedBV) {
        const elementsList = [
            this.avSelectContainer,
            this.avSelectCarousel,
            this.avSelectCarouselButton
        ];

        switch (selectedBV) {
            case this.bvZorgGemakValue:
                this._hideAvGemak();
                this._hideElements(elementsList);
                break;
            case this.bvGeenValue:
                this._hideAvGemak();
                this._showElements(elementsList);
                break;
            default:
                this._showElements(elementsList);
        }
    }

    _hideAvGemak() {
        /* NOTE: this is necessary because there are already other eventlisteners in the legacy modules that are
           enforcing state or redrawing the avSelect dropdown (ノಠ益ಠ)ノ彡┻━┻ */
        document.onreadystatechange = () => {
            if (document.readyState !== "loading") {
                const avGemakElements = Array.from(
                    this.container.querySelectorAll("[data-is-av-gemak]")
                );

                this._hideElements(avGemakElements);
                this._resetAvSelect(this.avSelect);
            }
        };
    }

    _resetAvSelect(element) {
        if (element) {
            element.value = "Geen-Geen";
        }
    }

    _showElements(elements) {
        for (let element of elements) {
            element && element.classList.remove("is-hidden");
            element && element.removeAttribute("style"); // Make sure no style="display: none" are leaving behind by other modules
        }
    }

    _hideElements(elements) {
        for (let element of elements) {
            element && element.classList.add("is-hidden");
        }
    }
}
